// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"a9eb7c48","278":"6ebc41bb","359":"21143516","896":"8216bbe5"}[chunkId] + ".chunk.js";
};